import { ComponentProps, MouseEvent, Suspense } from 'react';

import { Button } from '@flipster/react/design-system/button';
import webviewHandler from '@flipster/utils/webview-handler';

import { useIsWebview } from '../shared/webview';

interface Props extends Pick<ComponentProps<typeof Button>, 'hierarchy' | 'color' | 'size' | 'label' | 'css'> {
  href: string;
  locator?: string;
  logger?: (e: MouseEvent<HTMLAnchorElement>) => void;
}

const BaseLink = ({ href, locator, logger, ...buttonProps }: Props) => {
  const isWebview = useIsWebview();
  const isExternalLink = href.startsWith('https://');

  return (
    <Button
      as='a'
      href={href}
      newTab={isExternalLink}
      onClick={(e) => {
        logger?.(e);
        if (isWebview && locator != null) {
          e.preventDefault();
          webviewHandler.postMessage({
            action: 'link',
            params: { page: locator },
          });
        }
      }}
      {...buttonProps}
    />
  );
};

export const CustomLink = (props: Props) => {
  return (
    <Suspense>
      <BaseLink {...props} />
    </Suspense>
  );
};
